import { Navigate, Outlet } from 'react-router-dom';

import { routes } from 'app/routes/constants';
import { useLeadsAccess } from 'app/features/leads/hooks/use-leads-access';
import Loading from 'app/ui/components/molecules/loading';

export const LeadsRoute = () => {
  const { canAccessLeads, isLoading } = useLeadsAccess();

  if (isLoading) {
    return <Loading />;
  }

  if (!canAccessLeads) {
    return <Navigate to={routes.HOME} replace={true} />;
  }

  return <Outlet />;
};
